module.exports = __webpack_public_path__ + "static/img/dia-bubble-alert-pc.37762b0.png";